import { useEffect, useState } from "react";
import { TreeNode } from "../../../store/Models/Api/TreeList";
import { DropdownMenu } from "../DropdownMenu";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";

interface DependentDropdownsProps {
    initialNode: TreeNode;
    localizer: IStringLocalizer;
    onAnyDropdownChange?: (value: string) => void;
    onAllDropdrownsSelected?: (selectedNodes: TreeNode[]) => void;
    onNotAllDropdrownsSelected?: () => void;
    resetToInitialNode?: boolean;
    parentNodeName: string;
    childNodeName: string;
}

interface SelectedNodeAndValue {
    node: TreeNode;
    selectedValue: string;
}

const DependentDropdowns: React.FC<DependentDropdownsProps> = ({ initialNode, localizer, onAnyDropdownChange, onAllDropdrownsSelected, onNotAllDropdrownsSelected, resetToInitialNode
    , parentNodeName, childNodeName }) => {
    const defaultValue = "--";
    const parentIndex = 0;
    const initialNodeWithSelectedValue = {
        node: initialNode,
        selectedValue: defaultValue
    };

    const [nodesToDisplay, setNodesToDisplay] = useState<SelectedNodeAndValue[]>([initialNodeWithSelectedValue]);
   
    useEffect(() => {
        if (resetToInitialNode) {
            setNodesToDisplay([initialNodeWithSelectedValue]);
        }
    }, [resetToInitialNode]);

    const handleDropdownChange = (newValue: string, index: number) => {
        var newNodeToDisplay;

        var newSelectedNodes = index == nodesToDisplay.length - 1 ? nodesToDisplay.slice() : nodesToDisplay.slice(0, index + 1);
        nodesToDisplay[index].selectedValue = newValue;

        if (newValue != defaultValue) {
            newNodeToDisplay = {
                node: nodesToDisplay[index].node.children.first(c => c.userFacingDescription == newValue),
                selectedValue: defaultValue
            } as SelectedNodeAndValue;
            newSelectedNodes.push(newNodeToDisplay);
        }
      
        if (newNodeToDisplay && newNodeToDisplay.node.children.length > 0 || newValue == defaultValue) {
            if (onNotAllDropdrownsSelected) {
                onNotAllDropdrownsSelected();
            }
        } else {
            if (onAllDropdrownsSelected) {
                onAllDropdrownsSelected(newSelectedNodes.map(s => s.node));
            }
        }

        setNodesToDisplay(newSelectedNodes);

        if (onAnyDropdownChange) {
            onAnyDropdownChange(newValue);
        }
    }

    function localizeString(stringText: string): string {
        const hyphenIndex = stringText.indexOf('-');
    
        // If there's no hyphen, localize the entire string
        if (hyphenIndex === -1) {
            return localizer.localizeString(stringText);
        }
    
        // Split the string into the part before and after the hyphen
        const beforeHyphen = stringText.substring(0, hyphenIndex).trim();
        const afterHyphen = stringText.substring(hyphenIndex + 1).trim();
    
        // Check if the part before the hyphen is a number
        if (/^\d+$/.test(beforeHyphen)) {
            // Only localize the part after the hyphen
            const localizedAfterHyphen = localizer.localizeString(afterHyphen);
            // Return the combined string with the number intact
            return `${beforeHyphen} - ${localizedAfterHyphen}`;
        } else {
            // If the part before the hyphen is not a number, localize the entire string
            return localizer.localizeString(stringText);
        }
    }


    return (
        <>
        {nodesToDisplay.filter(n => n.node.children.length > 0).map((node, index) =>
            <div className="form-group" key={index}>
                <label>{index == parentIndex ? parentNodeName : childNodeName}</label>
                <DropdownMenu
                    options={[defaultValue].concat(node.node.children.map(c => c.userFacingDescription))}
                    getUniqueValueForOption={o => node.node.children.map(c => c.userFacingDescription).indexOf(o).toString()}
                    getFriendlyNameForOptions={o => localizeString(o)}
                    onOptionSelected={(value: string) => { handleDropdownChange(value, index); }}
                    preselectedOption={defaultValue}
                    key={index}
                    value={node.selectedValue}
                    id={`article-category-dropdown-${index}` }
                />
            </div>)}
        </>
    );
};

export default DependentDropdowns;